import React from 'react';
import { Link } from 'react-router-dom';
import { categoryPath } from '../../services/storefront';
import { openSearch } from '../storefront/storefrontEvents';
import AccentText from '../storefront/AccentText';
import { IconSearch } from '../storefront/icons';

const CHILD_PREVIEW = 8;

// A typeset directory of every collection and its categories.
const CatalogIndex = ({ roots, copy }) => (
  <section className="tp-section tp-index" aria-labelledby="tp-index-title">
    <div className="tp-container">
      <header className="tp-section-head" data-reveal>
        <div>
          <span className="tp-eyebrow" data-copy-key="catalog.eyebrow">{copy['catalog.eyebrow']}</span>
          <h2 id="tp-index-title" className="tp-display tp-section-head__title" data-copy-key="catalog.title">
            <AccentText text={copy['catalog.title']} />
          </h2>
        </div>
        <div className="tp-section-head__aside">
          <p data-copy-key="catalog.body">{copy['catalog.body']}</p>
          <button type="button" className="tp-index__search" onClick={openSearch} data-copy-key="catalog.searchLabel">
            <IconSearch size={18} />
            <span>{copy['catalog.searchLabel']}</span>
            <kbd>/</kbd>
          </button>
        </div>
      </header>

      <div className="tp-index__cols" data-reveal>
        {roots.map((root, i) => (
          <div key={root.id} className="tp-index__group">
            <Link to={categoryPath(root.id)} className="tp-index__root">
              <span className="tp-index__num">{String(i + 1).padStart(2, '0')}</span>
              <span className="tp-index__name">{root.name}</span>
              {root.children.length > 0 && <span className="tp-index__count">{root.children.length}</span>}
            </Link>
            {root.children.length > 0 && (
              <ul className="tp-index__children">
                {root.children.slice(0, CHILD_PREVIEW).map((child) => (
                  <li key={child.id}>
                    <Link to={categoryPath(child.id)}>{child.name}</Link>
                  </li>
                ))}
                {root.children.length > CHILD_PREVIEW && (
                  <li>
                    <Link to={categoryPath(root.id)} className="tp-index__more">
                      +{root.children.length - CHILD_PREVIEW} more
                    </Link>
                  </li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CatalogIndex;
